export const sortPrecios = function(a, b){
    const baseExponent = ("1".padEnd(10, '0'))
    return (+a.Codigo.replaceAll('.', '') + baseExponent) - (+b.Codigo.replaceAll('.', '') + baseExponent)
}